import type { Tokens } from '@aviata/platform-types';

export const parseJwt = (token: string): Record<string, unknown> | null => {
  try {
    return JSON.parse(atob(token.split('.')[1])) as Record<string, unknown>;
  } catch (e) {
    return null;
  }
};

export const getUserFromToken = (token: string) => {
  const parsedJwt = parseJwt(token);
  const { user } = parsedJwt as Tokens.UserToken;

  return user;
};
